import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
import chooseMedia from "@uni/video/lib/web/chooseMedia.js";
var chooseImage = normalize.chooseImage(function (args) {
  if (args === void 0) {
    args = {};
  }

  var _args = args,
      _args$count = _args.count,
      count = _args$count === void 0 ? 1 : _args$count,
      _args$success = _args.success,
      success = _args$success === void 0 ? function () {} : _args$success,
      _args$fail = _args.fail,
      fail = _args$fail === void 0 ? function () {} : _args$fail,
      _args$complete = _args.complete,
      complete = _args$complete === void 0 ? function () {} : _args$complete;
  chooseMedia({
    count: count,
    accept: 'image/*'
  }).then(function (res) {
    var result = {
      tempFilePaths: res.tempFiles.map(function (item) {
        return item.tempFilePath;
      }),
      tempFiles: res.tempFiles.map(function (item) {
        return {
          path: item.tempFilePath,
          size: item.size
        };
      }),
      files: res.files
    };
    success(result);
    complete(result);
  }).catch(function (e) {
    fail(e);
    complete(e);
  });
}, CONTAINER_NAME.WEB);
export default chooseImage;